module.exports = __webpack_public_path__ + "static/media/Google Drive.a1f70672.png";